import { c as _c } from "react/compiler-runtime";
import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import { ProductDownloadItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { getDigitalProductCheckoutErrorChecker, getThankYouErrorChecker, getThumbnailErrorChecker } from 'modules/stores/store/utils/get-error-checkers';
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs';
import { ProductDownloadTabEnum, tabLocoKeys } from '../enum/product-download-tab-enum';
import { getProductDownloadError } from '../utils/get-product-download-error';
export const useErrorMessageInTabs = () => {
  const $ = _c(2);
  const {
    formErrorMessage: formErrorMessageCommon
  } = useFormErrorMessageInTabs();
  const getTabsWithErrors = _temp;
  let t0;
  if ($[0] !== formErrorMessageCommon) {
    const formErrorMessage = t1 => {
      const {
        errors: errors_0,
        digitalProductErrors: digitalProductErrors_0
      } = t1;
      const tabsErrorsMap = getTabsWithErrors({
        errors: errors_0,
        digitalProductErrors: digitalProductErrors_0
      });
      return formErrorMessageCommon({
        tabsErrorsMap,
        tabsLocoKeys: tabLocoKeys
      });
    };
    t0 = {
      getTabsWithErrors,
      formErrorMessage
    };
    $[0] = formErrorMessageCommon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(t0) {
  const {
    errors,
    digitalProductErrors
  } = t0;
  const hasThumbnailError = getThumbnailErrorChecker(errors);
  const hasCheckoutError = getDigitalProductCheckoutErrorChecker(errors, digitalProductErrors);
  const hasThankYouError = getThankYouErrorChecker(errors);
  const hasProductErrors = getProductDownloadError(errors, digitalProductErrors);
  return {
    [ProductDownloadTabEnum.digital_download]: hasProductErrors,
    [ProductDownloadTabEnum.thumbnail]: hasThumbnailError,
    [ProductDownloadTabEnum.checkout]: hasCheckoutError,
    [ProductDownloadTabEnum.thank_you]: hasThankYouError
  };
}